// ✅ PHASE 3: Use single source of truth for API base URL
import { getApiBaseUrl } from '../config/region';

export const API_BASE_URL = getApiBaseUrl();

export const ONBOARDING_STATUS = {
  UNLISTED: 'UNLISTED',
  LISTED_UNCLAIMED: 'LISTED_UNCLAIMED',
  SOFT_ONBOARDED: 'SOFT_ONBOARDED',
  NOT_INTERESTED: 'NOT_INTERESTED',
  INTERESTED_LATER: 'INTERESTED_LATER',
  FULLY_VERIFIED: 'FULLY_VERIFIED'
};

export const STATUS_COLORS = {
  UNLISTED: '#FF6B6B',
  LISTED_UNCLAIMED: '#FFA07A',
  SOFT_ONBOARDED: '#FFD93D',
  NOT_INTERESTED: '#95A5A6',
  INTERESTED_LATER: '#A8DADC',
  FULLY_VERIFIED: '#6BCF7F'
};

export const PHOTO_TYPES = [
  'storefront',
  'interior',
  'menu',
  'selfie_staff',
  'selfie_owner',
  'selfie_manager',
  'food',
  'outdoor',
  'logo',
  'cover'
];

export const CATEGORIES = [
  'cafe',
  'restaurant',
  'coworking',
  'coffee_shop',
  'thai_food',
  'street_food',
  'bar',
  'hotel'
];
